const translations = {
    en: {
        translation: {
            "navbar": {
                "home": "Home",
                "lavita": "Home",
                "home_intro": "Hero",
                "intelligence": "Intelligence",
                "privacy_infrastructure": "Privacy Infrastructure",
                "connected_experience": "Connected Experience",
                "ecosystem": "Ecosystem",
                "download_app": "Download App",
                "about": "About",
                "team": "Contributors",
                "advisory_council": "Advisory Council",
                "whitepaper": "Whitepaper",
                "news": "News",
                "podcast": "Podcast",
                "episodes": "Episodes",
                "articles": "Library",
                "all_articles": "All Articles",
                "topics": "Topics",
                "components": "Components",
                "platform": "Platform",
                "lavita_platform": "Platform Overview",
                "user_workflow": "User Workflow",
                "demo": "Web Platform",
                "apps": "Mobile App",
                "docs": "Whitepaper",
                "resources": "Resources",
                "technology": "Technology",
                "key_components": "Technology Overview",
                "decentralized_blockchain": "Blockchain",
                "secure_data_storage": "Data Storage",
                "secure_computing": "Secure Computing",
                "ai_powered_research": "AI Research",
                "secure_key_management": "Key Management",
                "roadmap": "Roadmap",
                "stake": "Stake",
                "theme_light": "Light",
                "theme_dark": "Dark",
                "switch_to_light": "Switch to light mode",
                "switch_to_dark": "Switch to dark mode",
                "try_medical_ai_assist": "Explore the Medical Sphere",
                "try_medical_evaluation_sphere": "Join the Medical Sphere",
            },
            "home": {
                "heading": "WELCOME TO LAVITA",
                "title": "The first private health data marketplace powered by AI, blockchain & YOU.",
                "description_1": "LAVITA is a blockchain-AI based next generation healthcare platform, enabling the use of massive biomedical datasets for research while preserving individual privacy and ownership of data.",
                "description_2": "Our vision is to usher in a new era of privacy-preserving genomic and health data sharing and analysis to improve 8 Billion lives globally.",
                "intro_caption": "PRIVATE HEALTH INTELLIGENCE",
                "hero_eyebrow": "AI x MEDICAL x PRIVACY",
                "hero_title": "Health data becomes intelligent when privacy is built in from the start.",
                "hero_description": "Lavita turns fragmented biomedical and genomic data into a secure AI-ready ecosystem designed for research, care, and user-owned participation.",
                "cta_primary": "Explore Platform",
                "cta_secondary": "See The Ecosystem",
                "scroll_cue": "Scroll to activate",
                "visual_card_1_label": "AI inference status",
                "visual_card_1_value": "Private signal online",
                "visual_card_2_label": "Protected exchange layer",
                "visual_card_2_value": "Encrypted by design",
                "news_title": "Signals from the network",
                "final_cta_eyebrow": "START WITH THE LAVITA APP",
                "final_cta_title": "The mobile app is the primary way to join the network.",
                "final_cta_description": "For contributors and everyday users, Lavita begins on iOS and Android. Start with the app experience, then move deeper into the ecosystem.",
                "final_cta_button": "Discover the App",
                "action_eyebrow": "DOWNLOAD THE APP",
                "action_title": "Download Lavita on iOS and Android.",
                "action_description": "Start in the app for onboarding, contribution, and health data participation. Web access remains available as a secondary workspace.",
                "action_web_link": "Need the web platform instead? Open it here.",
                "stats": {
                    "privacy": "User-owned privacy architecture",
                    "intelligence": "AI-ready medical data flows",
                    "control": "Trusted participation at network scale"
                },
                "scenes": {
                    "ai": {
                        "eyebrow": "INTELLIGENCE ENGINE",
                        "title": "Biomedical data becomes a living signal layer.",
                        "description": "Lavita activates large-scale health and genomic datasets with AI workflows that feel less like storage and more like an intelligent operating system.",
                        "bullet_1": "Purpose-built for biomedical discovery",
                        "bullet_2": "Signals emerge through structured AI workflows",
                        "bullet_3": "Designed for research speed without visual clutter"
                    },
                    "privacy": {
                        "eyebrow": "PRIVACY INFRASTRUCTURE",
                        "title": "Protection is not a feature. It is the foundation.",
                        "description": "Every layer is shaped around secure participation, encrypted control, and privacy-preserving exchange so data can move without losing trust.",
                        "bullet_1": "Encrypted contribution and access control",
                        "bullet_2": "Privacy-first architecture across the platform",
                        "bullet_3": "Built to reduce exposure while increasing utility"
                    },
                    "ecosystem": {
                        "eyebrow": "CONNECTED EXPERIENCE",
                        "title": "One ecosystem across mobile, web, and marketplace layers.",
                        "description": "Users, researchers, and healthcare organizations meet inside a single visual and technical system that keeps the experience coherent across every touchpoint.",
                        "bullet_1": "Mobile participation for contributors",
                        "bullet_2": "Web platform access for advanced workflows",
                        "bullet_3": "A marketplace model aligned with data ownership"
                    }
                },
                "ecosystem": {
                    "eyebrow": "PLATFORM ECOSYSTEM",
                    "title": "Designed as a coordinated health data network.",
                    "description": "Each surface plays a distinct role, but the product experience stays unified, precise, and unmistakably Lavita.",
                    "mobile_title": "Mobile Entry Point",
                    "mobile_description": "Secure onboarding, contribution, and health data participation from a user-owned app experience.",
                    "web_title": "Web Intelligence Layer",
                    "web_description": "A focused environment for platform access, research workflows, and secure operational visibility.",
                    "marketplace_title": "Privacy-Preserving Exchange",
                    "marketplace_description": "A marketplace architecture where value, access, and trust can scale together."
                },
                "story_visual": {
                    "label_primary": "Core capability",
                    "label_secondary": "System effect",
                    "label_status": "Active scene"
                },
                "social_join": "Join us on social:",
                "recent_news": "Recent News",
                "view_more": "View More",
                "show_more_news": "Show More News",
            },
            "about":{
                "heading": "ABOUT LAVITA",
                "title_1": "Next generation privacy-preserving",
                "title_2": "genomic and health data marketplace",
                "description_1": "Lavita is a blockchain-AI based next generation healthcare technology company aiming to revolutionize the way 8 billion individuals around the world diagnose, analyze, and treat health and genomic issues, leading to earlier intervention and improved outcome.",
                "description_2": "The platform brings together state-of-the-art proprietary machine learning, biomedical natural language understanding models and semantic search algorithms to easily and accurately connect patients with the most relevant clinical trials in the fastest time possible, powered by a privacy-preserving decentralized health data marketplace.",
                "core_team": "Core Contributors",
                "advisory_council": "Advisory Council",
                "GENERATIVE_AI&_BIOMEDICAL_NLP": "GENERATIVE AI & BIOMEDICAL NLP",
                "SECURE_COMPUTING_&_PRIVACY": "SECURE COMPUTING & PRIVACY",
                "HEALTHCARE_&_BIOMEDICAL_INDUSTRIES": "HEALTH & BIOMEDICAL INDUSTRIES",
                "coming_soon": "COMING SOON",
            },
            "news":{
                "title": "News",
            },
            "podcast": {
                "title": "Podcast",
                "subtitle": "Listen to the latest health and wellness conversations from Lavita AI.",
                "loading": "Loading episodes…",
                "refresh": "Refresh episodes",
                "retry": "Try again",
                "empty": "No podcast episodes are available yet."
            },
            "platform":{
                "heading": "Overview",
                "title": "Lavita Secure Data Platform",
                "subtitle": "A decentralized data marketplace",
                "description_1": "Lavita is a next-generation decentralized, peer-to-peer data marketplace connecting health providers, health data contributors, and data miners. The platform empowers individuals to contribute their own private health and genomic data and be rewarded in LAVITA (Theta TNT-20 tokens) from data miners including pharmaceutical and research companies.",
                "description_2": "LAVITA tokens can in the future be used to pay for health services to healthcare institutions, and medical facilities. Lavita is the first Web3 health data platform built from the ground up leveraging blockchain, AI and privacy preserving technologies.",
                "user_workflow": "Lavita User Workflow",
                "user_workflow_card_1": "Use mobile app to create “encrypted” profile",
                "user_workflow_card_2": "Contribute and manage personal health data",
                "user_workflow_card_3": "Aggregated, encrypted, data used in studies",
                "user_workflow_card_4": "Earn digital token (cryptocurrency)",
            },
            "demo":{
                "platform_demo": "Platform Demo",
            },
            "apps":{
                "title": "Mobile App",
                "showcase_note": "A closer look at the contributor experience inside the Lavita app.",
                "secure_genomic_comparison": {
                    "title": "Secure Genomic Comparison",
                    "description": "By analyzing your genome data and comparing it to various databases, you can see how certain diseases are common among people who have the most similar genomes to yours.\n\nThe numbers next to a disease refer to the occurrence of each disease among those people in the database with a similar genomic profile to yours. This information can help you gain a better understanding of a genome profile and its implication for phenotypic traits and health risks."
                },
                "clinical_trial_matching": {
                    "title": "Clinical Trial Matching",
                    "description": "Clinical trials are an integral part of developing novel treatments for various diseases and disorders. And finding eligible volunteers and patients to participate in clinical trials is crucial to these trials’ success.\n\nIn our application, we securely match users with the most relevant clinical trials based on their demographic, health information, and clinical background and history. We have developed a set of state-of-the-art proprietary machine learning and biomedical natural language understanding models and algorithms to easily and accurately connect our users with the most relevant clinical trials in the fastest time possible."
                },
                "ancestry_profiling": {
                    "title": "Ancestry Profiling",
                    "description": "Genetic ancestry is a measure of individuals’ biogeographical origins, based on correlated allele frequency differences among ancestral source populations. Knowing genetic ancestry can provide useful insights about the geographic origins of individuals’ ancestors and even aid in the assessment of risk for some heritable conditions.\n\nIn this application, by leveraging genome-wide genetic variant data, including whole-genome sequences, whole exome sequences, and whole-genome genotypes, we analyze users’ raw genome data reports and determine their genetic ancestry categories. In particular, by leveraging our bioinformatic and machine learning tools and pipelines, we find and visualize the fractional estimates of ancestry components for genomic samples of users in a secure environment."
                }
            },
            "components":{
                "title": "5 Core Components of Lavita Technology",
                "description": "The Lavita platform consists of five integral modules: decentralized blockchain, secure data storage, secure computation (e.g., secure hardware, multiparty computation, homomorphic encryption, zero-knowledge proof, and differential privacy), AI supported research & validation applications (e.g., research engine, data validation tool), and Secure Key Management (SKM).",
                "sections":{
                    "01": {
                        "heading": "01 Platform Components",
                        "title": "Decentralized Blockchain powered by Theta subchain",
                        "description": "Lavita infrastructure is powered by smart contracts running on a customized Theta Subchain. This custom health data subchain enables full horizontal scalability, without sacrificing privacy and security."
                    },
                    "02": {
                        "heading": "02 Platform Components",
                        "title": "Secure Data Storage powered by ThetaEdge Store",
                        "description": "In the Lavita platform, distributed storage will be supported by decentralized storage infrastructure powered by Theta EdgeStore and Theta Edge Network. It provides a high-throughput, content-addressed, block storage model to efficiently handle large-scale genome data from different sources."
                    },
                    "03": {
                        "heading": "03 Platform Components",
                        "title": "Secure Computing with Intel SGX Technology and Theta Edge Network",
                        "description": "Data contributors in the Lavita platform send their encrypted genomic and healthcare data to the secure computing infrastructure powered by Intel SGX run by Theta edge nodes and obtain a hash value that uniquely identifies the data in the Lavita ecosystem. During the secure computing phase, Theta EdgeStore works directly with Secure Computing Nodes through the unique hash value recorded on blockchain via smart contracts."
                    },
                    "04": {
                        "heading": "04 Platform Components",
                        "title": "AI-powered Research & Data Validation",
                        "semantic_research_engine": {
                            "title": "Semantic Research Engine",
                            "description": "Lavita platform implements AI-supported Semantic Search engine and users receive well-informed genetic information and analysis based on their clinical needs. With the use of NLP based Semantic Search engine, the Lavita platform provides more accurate information to users, and healthcare institutions."
                        },
                        "data_quality_check": {
                            "title": "Data Quality Check",
                            "description": "In order to add more liquidity to the Lavita marketplace, incentive mechanisms are implemented to improve data quality. Data contributors receive more rewards for their time and quality of their contribution to data and qualitative surveys. This is enabled by the AI-Powered Data Quality Tool."
                        }
                    },
                    "05": {
                        "heading": "05 Platform Components",
                        "title": "Secure Key Management for Private Data",
                        "description": "The key to privacy-preserving computing lies in its power to enable data sharing and analysis among different entities without exposing data to theft.\n\nLavita platform utilizes privacy-preserving Secure Key Management(SKM), sensitive data can be protected and controlled during the entire data processing phases that were previously not possible."
                    }
                }
            },
            "roadmap":{
                "title": "Development Roadmap",
                "2026-1": {
                    "H1": {
                        title: '',
                        subTitle1: 'Launch Lavita AI Freemium Mobile App',
                        subTitle2: 'Personalized Podcasts and Content',
                        subTitle3: 'Access to the Latest Medical Knowledge',
                        content1: 'Launch on Android and iOS platform, with subscription-based features',
                        content2: 'Provide highly customizable audio and text content based on latest verified medical publications and according to each user\'s own preference',
                        content3: 'Bring thousands of academic and medical professional research articles to the users\' fingertips, to access personalized, up-to-date, insights on health, wellness, and medical innovation frontiers',
                    },
                },
                "2026-2": {
                    "H2": {
                        title: '',
                        subTitle1: 'Personal Health Tracker Data Integration',
                        subTitle2: 'Launch Secure Data Collaboration',
                        subTitle3: 'Launch (beta) Lavita Medical AI Agents',
                        content1: 'Expand data integration including data from wearables, nutrition, and other wellness platforms and accessories, such as Fitbit, Garmin, Oura, and others',
                        content2: 'Enable secure data collaboration and cohort creation (with potential for monetization) for users, powering LAVITA tokenomics',
                        content3: 'Novel agents to facilitate data collection and interpretation for users',
                    },
                },
            },
            "documents":{
                "heading": "Documents",
                "title": "Learn how to contribute, run nodes and earn rewards from the Lavita platform",
                "lavita_whitepaper": "LAVITA Whitepaper",
                "download": "Download",
            },
            "stake": {
                "title": "Stake LAVITA to help secure the Lavita Theta subchain and earn rewards.",
                "description": "Unstake your LAVITA at any time including pending rewards subject to a cooldown period.",
                "connect_your_wallet": "Connect Your Wallet",
                "available_on_ios_and_android": "Available on iOS and Android",
                "staking_paused": "LAVITA staking has been temporarily paused.",
                "disconnect": "Disconnect",
                "connected_to": "Connected to: ",
                "balance": "Balance",
                "staked_plus_rewards": "Staked + reward (est.)",
                "stake": "Stake",
                "unstake": "Unstake",
                "pending_withdrawals": "Pending Withdrawals",
                "claim": "Claim",
                "available_in": "Available in ~{{time}}",
                "available_to_claim": "Available to claim",
                "available_to_claim_legacy": "Available to claim - Legacy",
            },
            "claim": {
                "title": "Burn Character NFTs in exchange for LAVITA tokens",
                "connect_wallet": "Connect Your Wallet",
                "available_on_ios_and_android": "Available on iOS and Android",
                "paused_message": "LAVITA claiming has been temporarily paused.",
                "disconnect": "Disconnect",
                "burn_title": "Burn Character NFTs in exchange for LAVITA tokens",
                "balance": "Balance",
                "stake": "Stake Your LAVITA",
                "burn_all": "Burn All",
                "no_cards": {
                    "title": "No Cards to Burn",
                    "subtitle": "Make sure to withdraw your Lavita NFTs from ThetaDrop to a compatible wallet like MetaMask or ThetaWallet (iOS / Android)",
                    "button": "Open ThetaDrop"
                },
            },
            "modals": {
                "stake": {
                    "title": "Stake",
                    "balance": "Balance",
                    "all": "ALL",
                    "enter_amount": "Enter amount",
                    "stake": "Stake",
                    "insufficient_balance": "Insufficient balance",
                },
                "unstake": {
                    "title": "Unstake",
                    "staked": "Staked",
                    "enter_percentage": "Enter %",
                    "unstake": "Unstake",
                    "cooldown_message": "*LAVITA will be claimable after ~5 day cooldown"
                }
            },
            "cta": {
                "stake_apy": {
                    "title": "Stake LAVITA and earn up to "
                },
                "stake_apy_info": {
                    "title": "Stake and earn up to ",
                },
                "medical_sphere": {
                    "title": "Join the Medical Sphere",
                },
                "access_platform": {
                    "title": "Access Lavita Health Data Platform on",
                },
                "mobile": {
                    "title": "Mobile",
                },
                "or": {
                    "title": "or",
                },
                "web": {
                    "title": "Web",
                }
            }
        }
    },
};


export default translations;
